const constants = {
    PUSH_NOTIFICATION: '__PUSH_NOTIFICATION',
    DELETE_NOTIFICATION: '__DELETE_NOTIFICATION'
};

export default constants;